module.exports = __webpack_public_path__ + "static/okoy-2f2be50bd2ced358d6642ad9e66cb1b8.jpg";